import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    // Move tooltip content to body to avoid opacity inheritance
    if (this.hasContentTarget) {
      // Keep a reference to the content element before moving it
      this.content = this.contentTarget
      this.trigger = this.triggerTarget

      this.portalContainer = document.createElement('div')
      this.portalContainer.className = 'rate-tooltip-portal'
      this.portalContainer.style.position = 'fixed'
      this.portalContainer.style.zIndex = '9999'
      this.portalContainer.style.pointerEvents = 'none'

      // Move content to portal
      this.portalContainer.appendChild(this.content)
      document.body.appendChild(this.portalContainer)

      // Position on hover
      this.boundUpdatePosition = this.updatePosition.bind(this)
      this.boundShow = this.show.bind(this)
      this.boundHide = this.hide.bind(this)

      if (this.trigger) {
        // Desktop: hover
        this.trigger.addEventListener('mouseenter', this.boundShow)
        this.trigger.addEventListener('mouseleave', this.boundHide)

        // Mobile: click to toggle
        this.boundToggle = this.toggle.bind(this)
        this.trigger.addEventListener('click', this.boundToggle)

        // Close on click outside
        this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
        document.addEventListener('click', this.boundCloseOnClickOutside)
      }
    }
  }

  show() {
    if (this.content) {
      this.updatePosition()
      this.portalContainer.style.pointerEvents = 'auto'
      this.content.classList.remove('opacity-0', 'invisible')
      this.content.classList.add('opacity-100', 'visible')
      this.content.style.display = 'block'
      window.addEventListener('scroll', this.boundHide, { passive: true })
    }
  }

  hide() {
    if (this.content) {
      this.content.classList.add('opacity-0', 'invisible')
      this.content.classList.remove('opacity-100', 'visible')
      this.portalContainer.style.pointerEvents = 'none'
      window.removeEventListener('scroll', this.boundHide)
    }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.content && this.content.classList.contains('opacity-100')) {
      this.hide()
    } else {
      this.show()
    }
  }

  closeOnClickOutside(event) {
    if (this.content && this.content.classList.contains('opacity-100')) {
      if (!this.portalContainer.contains(event.target) && !this.trigger.contains(event.target)) {
        this.hide()
      }
    }
  }

  updatePosition() {
    if (!this.trigger || !this.content) return

    const triggerRect = this.trigger.getBoundingClientRect()
    const contentRect = this.content.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    // Position above trigger, centered
    let left = triggerRect.left + (triggerRect.width / 2) - (contentRect.width / 2)
    let top = triggerRect.top - contentRect.height - 8

    // Keep within viewport horizontally (with 10px margin)
    left = Math.max(10, Math.min(left, windowWidth - contentRect.width - 10))

    // Keep within viewport vertically (with 10px margin)
    top = Math.max(10, Math.min(top, windowHeight - contentRect.height - 10))

    this.portalContainer.style.left = `${left}px`
    this.portalContainer.style.top = `${top}px`
  }

  disconnect() {
    if (this.trigger) {
      this.trigger.removeEventListener('mouseenter', this.boundShow)
      this.trigger.removeEventListener('mouseleave', this.boundHide)
      this.trigger.removeEventListener('click', this.boundToggle)
    }
    window.removeEventListener('scroll', this.boundHide)
    document.removeEventListener('click', this.boundCloseOnClickOutside)

    if (this.portalContainer && this.portalContainer.parentNode) {
      this.portalContainer.parentNode.removeChild(this.portalContainer)
    }
  }
}
